import ChartColors from "src/components/chart-colors";
import * as React from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { TableSortLabel } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import timeSplitter from "src/utils/time-splitter";
import OverviewTablePagination from "src/scenes/overview/overview-components/details-tables/overview-table-pagination";

const columns = [
    { id: "name", label: "User", minWidth: 170 },
    {
        id: "longHours",
        label: "Long Working Hours",
        minWidth: 100,
        align: "left",
        isSortable: true,
    },
    {
        id: "outOfHours",
        label: "Out of hours working",
        minWidth: 100,
        align: "left",
        isSortable: true,
    },
    { id: "focus", label: "Available Focus Time", minWidth: 100, align: "left", isSortable: true },
];

const ArrayTableCredit = ({ data }) => {
    if (!data || data.length === 0) return null;
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [sortOrder, setSortOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("");

    const createUsers = data.map((detail, index) => {
        const user = `User ${index + 1}`;
        const color = ChartColors[index % ChartColors.length];
        return {
            name: user,
            longHours: detail.longHours,
            outOfHours: detail.outOfHours,
            focus: detail.focus,
            color,
        };
    });
    const users = createUsers;
    const createData = (name, longHours, outOfHours, focus, color) => {
        return { name, longHours, outOfHours, focus, color };
    };

    const rows = users.map((user) =>
        createData(user.name, user.longHours, user.outOfHours, user.focus, user.color)
    );

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const descendingComparator = (a, b) => {
        const aValue = a[orderBy];
        const bValue = b[orderBy];

        if (bValue < aValue) {
            return -1;
        }
        if (bValue > aValue) {
            return 1;
        }
        return 0;
    };

    const getComparator = () => {
        return sortOrder === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const stableSort = (array, comparator) => {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const sortedRows = stableSort(rows, getComparator(sortOrder, orderBy));

    const needsPagination = rowsPerPage < rows.length;

    return (
        <Paper sx={{ width: "100%", overflow: "hidden", marginTop: "8px", boxShadow: "none" }}>
            <TableContainer>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, fontSize: "12px" }}
                                >
                                    {column.isSortable ? (
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? sortOrder : "asc"}
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    ) : (
                                        column.label
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.name}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{
                                                        fontSize: "12px",
                                                        backgroundColor: "#333333",
                                                    }}
                                                >
                                                    {column.id === "name"
                                                        ? value
                                                        : ` ${timeSplitter(
                                                              Number(value),
                                                              "variable-accuracy"
                                                          )}
                                                            ${timeSplitter(Number(value), "text")}`}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            {needsPagination &&
                OverviewTablePagination({ rows, rowsPerPage, page, setPage, setRowsPerPage })}
        </Paper>
    );
};
export default ArrayTableCredit;
